export default __webpack_public_path__ + "static/media/Page13.4ec8404f.txt";